import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { DO_NOT_USE_FaWrapper } from '../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';
import { forwardRef, useEffect } from 'react';
import warning from 'warning';
import { Loader } from '../../../loader/index.js';
import { ResetButton } from './components/ResetButton/index.js';
import { InputContainer, Adornment, Input } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var SearchInput = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var value = props.value,
    onReset = props.onReset,
    disabled = props.disabled,
    onChange = props.onChange,
    resetLabel = props.resetLabel,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'outline' : _props$variant,
    _props$stretch = props.stretch,
    stretch = _props$stretch === void 0 ? false : _props$stretch,
    _props$invalid = props.invalid,
    invalid = _props$invalid === void 0 ? false : _props$invalid,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    className = props.className,
    rest = __rest(props, ["value", "onReset", "disabled", "onChange", "resetLabel", "variant", "stretch", "invalid", "loading", "className"]);
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      process.env.NODE_ENV !== "production" ? warning(!(onChange && value && !onReset), '"onReset" function is required when using controlled searched') : void 0;
      process.env.NODE_ENV !== "production" ? warning(!(onReset && !resetLabel), '"resetLabel" is required for accessibility when providing "onReset" function') : void 0;
    }, [resetLabel, onChange, value, onReset]);
  }
  var showReset = Boolean(value && onReset && !disabled);
  var inputProps = Object.assign(Object.assign({}, rest), {
    value: value,
    onChange: onChange,
    disabled: disabled,
    ref: forwardedRef
  });
  return /*#__PURE__*/jsxs(InputContainer, {
    $variant: variant,
    $invalid: invalid,
    $stretch: stretch,
    className: className,
    children: [/*#__PURE__*/jsx(Adornment, {
      children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
        icon: faMagnifyingGlass,
        $color: "text.100"
      })
    }), /*#__PURE__*/jsx(Input, _extends({
      type: "search"
    }, inputProps)), /*#__PURE__*/jsx(Adornment, {
      children: loading ? /*#__PURE__*/jsx(Loader, {
        size: 6
      }) : /*#__PURE__*/jsx(ResetButton, {
        show: showReset,
        onClick: onReset,
        label: resetLabel
      })
    })]
  });
});
SearchInput.displayName = 'SearchInput';

export { SearchInput };
